import { Outlet } from 'react-router'

import { Stack } from '@mui/material'
import { AppBar } from '@/components/AppBar'
import { Breadcrumbs } from '@/components/Breadcrumbs'
import { NavMenu } from '@/components/NavMenu/NavMenu'
import { Protected } from '@/components/Protected/Protected'
import { Title } from '@/components/Title/Title'
import { DRAWER_COLLAPSED_WIDTH, DRAWER_EXPANDED_WIDTH } from '@/constants/navigationDrawer'
import { labelMap, routes } from '@/router/routes'
import { useUiStore } from '@/stores/useUiStore'

const SAFE_HEIGHT_TOP_BAR_OFFSET = 70

export const ProtectedLayout = () => {
  const isNavExpanded = useUiStore((state) => state.isDesktopNavExpanded)

  return (
    <Protected>
      <Title />

      <Stack height="100vh" overflow="hidden">
        <AppBar />

        <Stack flexGrow={1} alignItems="start" component="main" flexDirection="row">
          <NavMenu drawerWidth={isNavExpanded ? DRAWER_EXPANDED_WIDTH : DRAWER_COLLAPSED_WIDTH} />
          <Stack
            component="main"
            direction="column"
            gap={2}
            flexGrow={1}
            p={3}
            width={
              isNavExpanded
                ? `calc(100vw - ${DRAWER_EXPANDED_WIDTH}px - .5rem)`
                : `calc(100vw - ${DRAWER_COLLAPSED_WIDTH}px - .5rem)`
            }
            height={`calc(100vh - ${SAFE_HEIGHT_TOP_BAR_OFFSET}px)`}
            overflow="auto"
          >
            <Breadcrumbs routes={routes} labelMap={labelMap} />
            <Outlet />
          </Stack>
        </Stack>
      </Stack>
    </Protected>
  )
}
